import React from 'react'
import { TemplateLookup, TemplateValue } from '../../../models/TemplateLibrary'
import { TEMPLATE_TYPES } from './TemplatesTab'

export interface TemplateTypeBadgeProps {
  templateValue: TemplateValue | TemplateLookup
}

const templateTypeNameByTemplate = (template: TemplateValue | TemplateLookup) => {
  return (
    TEMPLATE_TYPES.find((tab) => tab.searchParams?.type === template.type && (!tab.searchParams?.typeId || tab.searchParams.typeId === template.typeId))
      ?.label || 'Template'
  )
}
export const TemplateTypeBadge: React.FC<TemplateTypeBadgeProps> = ({ templateValue }) => {
  return <p className='mb-0 paragraph-small template-badge zocks-bg-color-gray-200'>{templateTypeNameByTemplate(templateValue)}</p>
}
